import React, { useState, useContext, useEffect, useCallback } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { GeneralContext } from "../../Contexts/GeneralContext";
import { EstablishmentContext } from "../../Contexts/EstablishmentContext";
import { PageHeader, Button, Card, Drawer, Space } from "antd";
import { ReadOutlined, CoffeeOutlined, TrophyOutlined } from "@ant-design/icons";
import { UPDATE_CARD } from "./gql_Cards";
import { GET_CATEGORIES } from "../Dishes/gql_Categories";
import { GET_DRINK_TYPES } from "../Drinks/gql_Drinks";
import { GET_WINE_TYPES } from "../Wines/gql_Wines";
import { useHistory, useLocation } from "react-router-dom";
import Dish from "./Dish";
import Drink from "./Drink";
import Wine from "./Wine";

const OneCardDetails = () => {

    const { general, handleSetGeneral } = useContext(GeneralContext);
    const { establishment } = useContext(EstablishmentContext);

    const lang = general.langue ? general.langue : 'fr';

    const location = useLocation()
    const history = useHistory()

    const [title, setTitle] = useState('La Carte')
    const [subTitle, setSubTitle] = useState('de votre restaurant')
    const [categories, setCategories] = useState([])
    const [esta, setEsta] = useState('©2021 - Safe Cards')
    const [visible, setVisible] = useState(false)
    const [visibleDrink, setVisibleDrink] = useState(false)
    const [visibleWine, setVisibleWine] = useState(false)
    const [allEstaDishes, setAllEstaDishes] = useState([])
    const [allEstaDrinks, setAllEstaDrinks] = useState([])
    const [allEstaWines, setAllEstaWines] = useState([])
    const [cardContent, setCardContent] = useState(undefined)
    const [drinkContent, setDrinkContent] = useState(undefined)
    const [wineContent, setWineContent] = useState(undefined)
    const [drinkTypes, setDrinkTypes] = useState([])
    const [wineTypes, setWineTypes] = useState([])

    const [getCategories] = useLazyQuery(GET_CATEGORIES, {
        onError: error_gc => console.log("error_gc", JSON.stringify(error_gc)),
        onCompleted: data_gc => createAllEstaDishes(data_gc),
        fetchPolicy: "no-cache",
    });

    const [getDrinkTypes] = useLazyQuery(GET_DRINK_TYPES, {
        onError: error_gdt => console.log("error_gdt", JSON.stringify(error_gdt)),
        onCompleted: data_gdt => createAllEstaDrinks(data_gdt),
        fetchPolicy: "no-cache",
    });

    const [getWineTypes] = useLazyQuery(GET_WINE_TYPES, {
        onError: error_gdt => console.log("error_gdt", JSON.stringify(error_gdt)),
        onCompleted: data_gdt => createAllEstaWines(data_gdt),
        fetchPolicy: "no-cache",
    });

    const [updateCard, {error: error_uc}] = useMutation(UPDATE_CARD, {
        onError: (error_um) => console.log("error_um :: ", JSON.stringify(error_um)),
        onCompleted: (data_um) => handleRefresh(data_um.updateCard.card),
        fetchPolicy: "no-cache",
    });

    const handleRefresh = useCallback((datas) => {
        if (datas) {
            defineCard(datas)
            defineDrinks(datas)
            defineWines(datas)
            getCategories({ variables: { establishment: establishment.id } });
            getDrinkTypes({ variables: { establishments: establishment.id } });
            getWineTypes({ variables: { establishments: establishment.id } });
        }
    }, [])

    //////////////// tous les plats ////
    //////////////// tous les plats ////
    //////////////// tous les plats ////

    const getPaneName = (panName) => {
        const lang = general.langue ? general.langue : 'fr';
        const tempName = Object.entries(JSON.parse(panName)).find((n, i) => {
            return lang === n[0]
        })
        return tempName[1]
    }

    const createAllEstaDishes = (datas) => {
        const newPanes = datas.categories.map((pane,i) => {
            return {
                rank: JSON.parse(pane.rank),
                title: getPaneName(pane.name),
                content: pane.dishes.map((dish,i) =>
                    <DishInList
                        key={i}
                        categories={categories}
                        cat={pane.id}
                        cats={datas.categories}
                        dish={dish}
                    />),
                key: pane.id,
            }
        })
        // newPanes.sort((a, b) => a.rank - b.rank)
        newPanes.sort((a, b) => (a.rank > b.rank) ? 1 : -1)
        setAllEstaDishes([...newPanes])
    }

    const DishInList = ({ dish }) => {
        const alreadyOnThisCards = dish.cards.map(card => card.id)
        const check = alreadyOnThisCards.indexOf(cardContent.id) !== -1 ? true : false
        return dish.active
            ? (
                <Button
                    type="link"
                    style={{ width: "100%", textAlign: "left", margin: "0 0 0.5em 0" }}
                    disabled={check}
                    onClick={() => handleAddDishToCard(dish.id)}
                >
                    <span style={{ fontWeight: "500" }}>{dish.name}</span>
                </Button>
            )
            : (
                <Button
                    type="link"
                    style={{ width: "100%", textAlign: "left", margin: "0 0 0.5em 0" }}
                    disabled={true}
                >
                    {dish.name}
                </Button>
            )
    }

    const handleAddDishToCard = (id) => {
        const alreadyInCard = cardContent.dishes.map(d => d.id)
        const zavars = {
            id: cardContent.id,
            dishes: [...alreadyInCard, id],
        }
        updateCard({ variables: zavars })
    }

    const handleOnClose = () => {
        setVisible(false)
    }

    const viewAllEstaDishes = () => {
        return allEstaDishes.length > 0
            ? (
                allEstaDishes.sort((first, second) => first.title > second.title ? 1 : -1 ).map((cat,i) => {

                    return (
                        <div key={i}>
                            <h3>{cat.title}</h3>
                            {cat.content.sort((first, second) => first.props.dish.id > second.props.dish.id ? 1 : -1 ).map(d => (console.log("d :: ", d),d))}
                        </div>
                    )
                })
            )
            : null
    }

    const handleDeleteDish = (e) => {
        const alreadyInCard = cardContent.dishes.map(d => d.id)
        const index = alreadyInCard.indexOf(e)
        alreadyInCard.splice(index, 1);
        const zavars = {
            id: cardContent.id,
            dishes: [...alreadyInCard],
        }

        if (categories.length < 2) {
            setCategories([])
        }

        updateCard({ variables: zavars })
    }

    //////////////////////////////////////////////// tous les plats ////
    //////////////////////////////////////////////// tous les plats ////
    //////////////////////////////////////////////// tous les plats ////



    //////////////// toutes les boissons ////
    //////////////// toutes les boissons ////
    //////////////// toutes les boissons ////

    const createAllEstaDrinks = (datas) => {

        const newPanes = datas.drinkTypes.map((pane) => {
            // console.log("pane :: ", pane)
            return {
                title: pane.name,
                content: pane.drinks.map((drink,i) =>
                    <DrinkInList
                        drinkTypes={drinkTypes}
                        types={datas.drinkTypes}
                        drink={drink}
                        type={pane.id}
                        key={i}
                    />),
                id: JSON.parse(pane.id),
            }
        })
        newPanes.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
        setAllEstaDrinks([...newPanes])
    }

    const DrinkInList = ({ drink }) => {

        const alreadyOnThisCards = drink.cards.map(card => card.id)
        const check = alreadyOnThisCards.indexOf(cardContent.id) !== -1 ? true : false
        return drink.active
            ? (
                <Button
                    type="link"
                    style={{ width: "100%", textAlign: "left", margin: "0 0 0.5em 0" }}
                    disabled={check}
                    onClick={() => handleAddDrinkToCard(drink.id)}
                >
                    <span style={{ fontWeight: "500" }}>{drink.name}</span>
                </Button>
            )
            : (
                <Button
                    type="link"
                    style={{ width: "100%", textAlign: "left", margin: "0 0 0.5em 0" }}
                    disabled={true}
                >
                    {drink.name}
                </Button>
            )
    }

    const handleAddDrinkToCard = (id) => {
        const alreadyInCard = drinkContent.drinks.map(d => d.id)
        const zavars = {
            id: drinkContent.id,
            drinks: [...alreadyInCard, id],
        }
        updateCard({ variables: zavars })
    }

    const handleOnCloseDrink = () => {
        setVisibleDrink(false)
    }

    const viewAllEstaDrinks = () => {
        return allEstaDrinks.length > 0
            ? (
                allEstaDrinks.sort((first, second) => first.title > second.title ? 1 : -1 ).map((ed,i) => {
                    return (
                        <div key={i}>
                            <h3>{ed.title}</h3>
                            {ed.content.sort((first, second) => first.props.drink.id > second.props.drink.id ? 1 : -1 ).map(d => d)}
                        </div>
                    )
                })
            )
            : null
    }

    const handleDeleteDrink = (e) => {
        const alreadyInCard = drinkContent.drinks.map(d => d.id)
        const index = alreadyInCard.indexOf(e)
        alreadyInCard.splice(index, 1);
        const zavars = {
            id: drinkContent.id,
            drinks: [...alreadyInCard],
        }

        if (drinkTypes.length < 2) {
            setDrinkTypes([])
        }

        updateCard({ variables: zavars })
    }

    //////////////////////////////////////////////// toutes les boissons ////
    //////////////////////////////////////////////// toutes les boissons ////
    //////////////////////////////////////////////// toutes les boissons ////



    //////////////// tous les vins ////
    //////////////// tous les vins ////
    //////////////// tous les vins ////

    const createAllEstaWines = (datas) => {

        const newPanes = datas.wineTypes.map((pane) => {

            return {
                title: pane.name,
                content: pane.wines.map((wine,i) =>
                    <WineInList
                        wineTypes={wineTypes}
                        types={datas.wineTypes}
                        wine={wine}
                        type={pane.id}
                        key={i}
                    />),
                id: JSON.parse(pane.id),
            }
        })

        newPanes.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0))
        setAllEstaWines([...newPanes])
    }

    const WineInList = ({ wine }) => {

        const alreadyOnThisCards = wine.cards.map(card => card.id)
        const check = alreadyOnThisCards.indexOf(cardContent.id) !== -1 ? true : false
        return wine.active
            ? (
                <Button
                    type="link"
                    style={{ width: "100%", textAlign: "left", margin: "0 0 0.5em 0" }}
                    disabled={check}
                    onClick={() => handleAddWineToCard(wine.id)}
                >
                    <span style={{ fontWeight: "500" }}>{wine.name}</span>
                </Button>
            )
            : (
                <Button
                    type="link"
                    style={{ width: "100%", textAlign: "left", margin: "0 0 0.5em 0" }}
                    disabled={true}
                >
                    {wine.name}
                </Button>
            )
    }

    const handleAddWineToCard = (id) => {
        const alreadyInCard = wineContent.wines.map(d => d.id)
        const zavars = {
            id: wineContent.id,
            wines: [...alreadyInCard, id],
        }
        updateCard({ variables: zavars })
    }

    const handleOnCloseWine = () => {
        setVisibleWine(false)
    }

    const viewAllEstaWines = () => {
        return allEstaWines.length > 0
            ? (
                allEstaWines.map((ew,i) => {
                    return (
                        <div key={i}>
                            <h3>{ew.title}</h3>
                            {ew.content.map(d => d)}
                        </div>
                    )
                })
            )
            : null
    }

    const handleDeleteWine = (e) => {
        const alreadyInCard = wineContent.wines.map(w => w.id)
        const index = alreadyInCard.indexOf(e)
        alreadyInCard.splice(index, 1);
        const zavars = {
            id: wineContent.id,
            wines: [...alreadyInCard],
        }

        if (wineTypes.length < 2) {
            setWineTypes([])
        }

        updateCard({ variables: zavars })
    }

    //////////////////////////////////////////////// tous les vins ////
    //////////////////////////////////////////////// tous les vins ////
    //////////////////////////////////////////////// tous les vins ////

    const handleBackToCards = () => {
        history.push({ pathname: "/cartes", card: location.card })
    }

    useEffect(() => {

        if (location.card) {
            defineCard(location.card)
            defineDrinks(location.card)
            defineWines(location.card)
            handleSetGeneral({
                ...general,
                localCardContent: location.card,
                page: "/cartedetails",
            })
        } else {
            const localCardContent = general.localCardContent
            if (localCardContent !== undefined) {
                defineCard(JSON.parse(localCardContent))
                defineDrinks(JSON.parse(localCardContent))
                defineWines(JSON.parse(localCardContent))
                handleSetGeneral({
                    ...general,
                    page: "/cartedetails",
                })
            }
        }
        if (location.establishment) {
            setEsta(`- ${location.establishment.Name} -`)
        }
        if (establishment) {
            getCategories({ variables: { establishment: establishment.id } });
            getDrinkTypes({ variables: { establishments: establishment.id } });
            getWineTypes({ variables: { establishments: establishment.id } });
        }

    }, []);

    useEffect(() => {
        if (cardContent !== undefined) {
            defineCard(cardContent)
        }
    }, [lang]);

    const defineCard = (vars) => {
        setTitle(vars.name)
        setSubTitle(vars.description)
        // setPrice(vars.price)
        let newCategories = [];
        let tempCategories = [];
        let temp2Categories = [];
        vars.dishes.map(cat => {
            if (cat.active) {
                const catRaw = cat.categories[0].name
                const catRank = cat.categories[0].rank
                const catTrad = Object.entries(JSON.parse(catRaw))
                    .find(cat => {
                        return (cat[0] === lang)
                            ? tempCategories.push(JSON.stringify([cat[1], catRank]))
                            : undefined
                    })
                tempCategories.map(cat => {
                    return temp2Categories.indexOf(cat) === -1
                        ? temp2Categories.push(cat)
                        : null
                })
                newCategories = temp2Categories.map(cat => JSON.parse(cat))
                newCategories.sort((a, b) => a[1] - b[1])
                setCategories(newCategories)
            }
        })

        setCardContent(vars)
    }

    const defineDrinks = (vars) => {
        let tempBoissons = []
        let uniq = []
        vars.drinks.map((boisson, i) => {
            if (boisson.active) {
                const boissonType = boisson.drink_types[0].name
                tempBoissons.push(boissonType)
                uniq = [...new Set(tempBoissons)];
                if (i + 1 === vars.drinks.length) {
                    uniq.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0))
                    setDrinkTypes(uniq)
                }
            }
        })
        setDrinkContent(vars)
    }

    const defineWines = (vars) => {
        let tempVins = []
        let uniq = []
        vars.wines.map((vin, i) => {
            if (vin.active) {
                const vinType = vin.wine_types[0].name
                tempVins.push(vinType)
                uniq = [...new Set(tempVins)];
                if (i + 1 === vars.wines.length) {
                    uniq.sort((a, b) => (a > b) ? 1 : ((b > a) ? -1 : 0))
                    setWineTypes(uniq)
                }
            }
        })
        setWineContent(vars)
    }

    const getCardContent = () => {
        if (categories.length > 0) {
            return (
                categories.sort((first, second) => first > second ? 1 : -1 ).map((cat,i) => {
                    return (
                        <Card bordered={false} key={i}>
                            <Space style={{ background: "green", width: "100%", textAlign: "center" }}>
                                <h2 className="catTitleInCard"><ReadOutlined /> {cat[0]}</h2>
                            </Space>
                            {cardContent.dishes.sort((first, second) => first.id > second.id ? 1 : -1 ).map((dish,i) => {
                                const tempCat = Object.entries(JSON.parse(dish.categories[0].name))
                                const tempCat2 = tempCat.filter(tc => lang === tc[0] ? tc : null)
                                const transCat = tempCat2.map(tc => tc[1])
                                return transCat[0] === cat[0]
                                    ? <Dish key={i} dish={dish} handleDeleteDish={handleDeleteDish} />
                                    : null
                            })}
                        </Card>
                    )
                })
            )
        }
    }

    const getDrinkContent = () => {
        if (drinkTypes.length > 0) {
            return (
                drinkTypes.sort((first, second) => first > second ? 1 : -1 ).map((dt,i) => {
                    return (
                        <Card bordered={false} key={i}>
                            <Space style={{ background: "green", width: "100%", textAlign: "center" }}>
                                <h2 className="catTitleInCard"><CoffeeOutlined /> {dt}</h2>
                            </Space>
                            {drinkContent.drinks.sort((first, second) => first.id > second.id ? 1 : -1 ).map((drink, i) => {
                                // console.log("drink :: ", drink)
                                return drink.drink_types[0].name === dt
                                    ? <Drink key={i} drink={drink} handleDeleteDrink={handleDeleteDrink} />
                                    : null
                            })}
                        </Card>
                    )
                })
            )
        }
    }

    const getWineContent = () => {
        if (wineTypes.length > 0) {
            return (
                wineTypes.sort((first, second) => first > second ? 1 : -1 ).map((dt,i) => {
                    return (
                        <Card bordered={false} key={i}>
                            <Space style={{ background: "green", width: "100%", textAlign: "center" }}>
                                <h2 className="catTitleInCard"><TrophyOutlined /> {dt}</h2>
                            </Space>
                            {wineContent.wines.sort((first, second) => first.id > second.id ? 1 : -1 ).map((wine, i) => {
                                return wine.wine_types[0].name === dt
                                    ? <Wine ey={i} wine={wine} handleDeleteWine={handleDeleteWine} />
                                    : null
                            })}
                        </Card>
                    )
                })
            )
        }
    }

    //////////////////////////////////// return ////////
    //////////////////////////////////// return ////////

    if (error_uc) return <p>{JSON.stringify(error_uc)}</p>

    return (
        <div>

            <Drawer // pour les plats
                title="Ajouter un plat"
                placement="right"
                closable={false}
                onClose={() => handleOnClose()}
                visible={visible}
                getContainer={false}
                width="350px"
                style={{ position: 'fixed' }}
            >
                {viewAllEstaDishes()}
            </Drawer>

            <Drawer // pour les boissons
                title="Ajouter une boisson"
                placement="right"
                closable={false}
                onClose={() => handleOnCloseDrink()}
                visible={visibleDrink}
                getContainer={false}
                width="350px"
                style={{ position: 'fixed' }}
            >
                {viewAllEstaDrinks()}
            </Drawer>

            <Drawer // pour les vins
                title="Ajouter une référence"
                placement="right"
                closable={false}
                onClose={() => handleOnCloseWine()}
                visible={visibleWine}
                getContainer={false}
                width="350px"
                style={{ position: 'fixed' }}
            >
                {viewAllEstaWines()}
            </Drawer>

            <PageHeader
                style={{ padding: "0 0 24px 0" }}
                className="site-page-header"
                title={title}
                subTitle={`${subTitle}`}
            />
            <div className="buttons-top">

                <Button
                    onClick={() => handleBackToCards()}
                    type="primary"
                    ghost
                    style={{ margin: "0 1em 16px 0" }}
                >
                    Retour
                </Button>

                <Button style={{ margin: "0 1em 16px 0" }} type="primary" onClick={() => setVisible(true)}>
                    + Plats
                </Button>

                <Button style={{ margin: "0 1em 16px 0" }} type="primary" onClick={() => setVisibleDrink(true)}>
                    + Boissons
                </Button>

                <Button style={{ margin: "0 1em 16px 0" }} type="primary" onClick={() => setVisibleWine(true)}>
                    + Vins
                </Button>

            </div>

            <Card
                style={{
                    borderColor: "#2ec2ca",
                    padding: "10px 0"
                }}
                className="cardContent in-card-details-00"
            >
                {getCardContent()}
                {getDrinkContent()}
                {getWineContent()}
                <div style={{
                    color: "#888888",
                    padding: "1em 0",
                    margin: "0",
                    width: "100%"
                }}
                    align='center'>
                    {esta}
                </div>

            </Card>
        </div>
    );
};

export default OneCardDetails;